import { ScheduledBroadcastStore } from './ScheduledBroadcastStore';
import { ScheduleServiceOutput } from './ScheduleServiceOutput';
// Schema and helpers belong to the service (handling logic)
export class ScheduleService {
    static instance;
    output;
    scheduledBroadcastStore;
    static getInstance() {
        if (!ScheduleService.instance) {
            ScheduleService.instance = new ScheduleService();
        }
        return ScheduleService.instance;
    }
    static getNotificationInterface() {
        return ScheduleService.getInstance();
    }
    static getOutput() {
        return ScheduleServiceOutput.getReactiveOutput();
    }
    async init() {
        // ToDo: Implement initialization
    }
    constructor() {
        this.output = new ScheduleServiceOutput();
        this.scheduledBroadcastStore = new ScheduledBroadcastStore();
        this.publishToOutput();
    }
    publishToOutput() {
        this.output.setBroadcasts(this.scheduledBroadcastStore.getScheduledBroadcasts());
    }
    // Notifications to be called by React components
    notifyAddScheduledBroadcast(broadcast) {
        this.scheduledBroadcastStore.addScheduledBroadcast(broadcast);
        this.publishToOutput();
    }
    notifyUpdateScheduledBroadcast(scheduledBroadcast) {
        this.scheduledBroadcastStore.updateScheduledBroadcast(scheduledBroadcast);
        this.publishToOutput();
    }
    notifyDeleteScheduledBroadcast(id) {
        this.scheduledBroadcastStore.deleteScheduledBroadcast(id);
        this.publishToOutput();
    }
    notifyClearScheduledBroadcasts() {
        this.scheduledBroadcastStore.clearScheduledBroadcasts();
        this.publishToOutput();
    }
    // TODO: maybe better name for this method and related classes as most of the broadcasts are not scheduled (i.e. created by the "Schedule" functionality from the UI)
    getScheduledBroadcast(streamId) {
        return this.scheduledBroadcastStore
            .getScheduledBroadcasts()
            .find((b) => b.streamId === streamId);
    }
    getRequiredScheduledBroadcast(streamId) {
        const scheduledBroadcast = this.getScheduledBroadcast(streamId);
        if (!scheduledBroadcast) {
            throw new Error('Invalid context: no scheduled broadcast found');
        }
        return scheduledBroadcast;
    }
}
